// function MatomoTracker() {
//     if (!(this instanceof MatomoTracker)) {
//         return new MatomoTracker();
//     }

//     window._mtm = window._mtm || [];

//     this.push = function(data) {
//         window._mtm.push(data);
//     };

//     this.trackPageView = function() {
//         this.push({'event': 'mtm.PageView'})
//     }

//     this.addToCart = function(productSKU, productName, productCategory, productPrice, productAmount) {
//         this.push({
//             'event': 'addEcommerceItem',
//             'productSKU': productSKU,
//             'productName': productName,
//             'productCategory': productCategory,
//             'productPrice': productPrice,
//             'quantity': productAmount
//         });        
//     };

//     this.productClick = function(productSKU, productName, productCategory, productPrice) {
//         // this.push([{
//         //     'event': 'setEcommerceView',
//         //     'id': productSKU,
//         //     'name': productName,
//         //     'category': productCategory,
//         //     'price': productPrice
//         // }]);
//         window._paq.push(['setEcommerceView', productSKU, productName, productCategory, productPrice]);
//     };

//     this.checkout = function(orderIdOrData, orderTotal, orderSubTotal, orderTax, orderShipping, orderDiscount) {
//         let data;

//         if (typeof orderIdOrData === 'object') {
//             // If the first argument is an object, use it as the data object.
//             data = orderIdOrData;
//         } else {
//             // If individual arguments are provided, create a data object from them.
//             data = {
//                 orderId: orderIdOrData,
//                 orderTotal,
//                 orderSubTotal,
//                 orderTax,
//                 orderShipping,
//                 orderDiscount,
//             };
//         }

//         this.push({
//             'event': 'E-handel - kassan',
//             'orderId': data.orderId,
//             'orderTotal': data.orderTotal,
//             'orderSubTotal': data.orderSubTotal,
//             'orderTax': data.orderTax,
//             'orderShipping': data.orderShipping,
//             'orderrabatt': data.orderDiscount
//         });
//     };
// }

// export default MatomoTracker;

function MatomoTracker() {
    if (!(this instanceof MatomoTracker)) {
        return new MatomoTracker();
    }

    window._mtm = window._mtm || [];

    this.push = function(data) {
        window._mtm.push(data);
    };

    this.trackPageView = function(data) {
        if(data == undefined || data == null) {
            data = {}
        }

        const d = {
            'event': 'mtm.PageView',
            'ageGroup': data.ageGroup || undefined,
            'amenities': data.amenities || undefined,
            'campainCode': data.campainCode || undefined,
            'cottageOrApartmentNumber': data.cottageOrApartmentNumber || undefined,
            'dateRange': data.dateRange || undefined,
            'endDate': data.endDate || undefined,
            'listView': data.listView || undefined,
            'loginStatus': data.loginStatus || undefined,
            'numberOfPeople': data.numberOfPeople || undefined,
            'pagePath': data.pagePath || undefined,
            'pageTitle': data.pageTitle || undefined,
            'place': data.place || undefined,
            'skill': data.skill || undefined,
            'sortBy': data.sortBy || undefined,
            'startDate': data.startDate || undefined,
            'type': data.type || undefined
        }

        this.push(d);
    }

    this.addToCart = function(productSKU, productName, productCategory, price, quantity) {
        this.push({
            'event': 'addEcommerceItem',
            'productSKU': productSKU,
            'productName': productName,
            'productCategory': productCategory,
            'price': price,
            'quantity': quantity
        });        
    };

    this.productClick = function(productSKU, productName, categoryName, price) {
        this.push({
            'event': 'setEcommerceView',
            'productSKU': productSKU,
            'productName': productName,
            'categoryName': categoryName,
            'price': price
        });
    };

    this.checkout = function(orderIdOrData, orderTotal, orderSubTotal, orderTax, orderShipping, orderDiscount) {
        let data;

        if (typeof orderIdOrData === 'object') {
            // If the first argument is an object, use it as the data object.
            data = orderIdOrData;
        } else {
            // If individual arguments are provided, create a data object from them.
            data = {
                orderId: orderIdOrData,
                orderTotal,
                orderSubTotal,
                orderTax,
                orderShipping,
                orderDiscount,
            };
        }

        this.push({
            'event': 'trackEcommerceOrder',
            'orderId': data.orderId,
            'orderTotal': data.orderTotal,
            // 'orderSubTotal': data.orderSubTotal,
            // 'orderTax': data.orderTax,
            // 'orderShipping': data.orderShipping,
            // 'orderDiscount': data.orderDiscount
        });
    };

    this.checkoutConfirmation = function(orderId, orderTotal) {
        this.push({
            'event': 'trackEcommerceOrder',
            'orderId': orderId,
            'orderTotal': orderTotal,
        });
    };

    // addEcommerceItem( productSKU, [productName], [productCategory], [price], [quantity] ) 
    this.pushProductClick = function(productSKU, productName, productCategory, price, quantity) {
        this.push({
            'event': 'trackEvent',
            'productSKU': productSKU,
            'productName': productName,
            'productCategory': productCategory,
            'price': price,
            'quantity': quantity
        })
    }

    this.removeFromCart = function(productSKU, grandTotal) {
        this.push({
            'event': 'removeEcommerceItem',
            'productSKU': productSKU,
            'quantity': 1
        })
        this.push({
            'event': 'trackEcommerceCartUpdate',
            'grandTotal': grandTotal
        })
    }
}

export default MatomoTracker;